module.exports = __webpack_public_path__ + "static/media/lascalles01_small@3x.cb91a628.jpg";